export default "__VITE_ASSET__D8q28rKS__"